import React from 'react';
// import PropTypes from 'prop-types';
import { ReactComponent as OverlayFull } from 'svg/overlay.svg';
import { ReactComponent as Unreal } from 'svg/unreal.svg';
import { ReactComponent as Reality } from 'svg/reality.svg';

import style from './style.module.css';

const Overlay = () => {
  return (
    <div className={style.overlay}>
      <OverlayFull className={`${style.full} hide-mobile`} />
      <Unreal className={`${style.unreal} hide-desktop`} />
      <Reality className={`${style.reality} hide-desktop`} />
    </div>
  );
};

Overlay.propTypes = {};

Overlay.defaultProps = {};

export default Overlay;
